import { AMAZON_API_DOMAIN_PARAMETERS } from '../../../constants/constants';
import amazonDomainFlags from './amazonDomainFlags';

export const AMAZON_DOMAINS = {
  'com': { tag: AMAZON_API_DOMAIN_PARAMETERS.com.PartnerTag, name: 'ארה"ב', flag: amazonDomainFlags['com'] },
  'co.uk': { tag: AMAZON_API_DOMAIN_PARAMETERS['co.uk'].PartnerTag, name: 'בריטניה', flag: amazonDomainFlags['co.uk'] },
  'de': { tag: AMAZON_API_DOMAIN_PARAMETERS.de.PartnerTag, name: 'גרמניה', flag: amazonDomainFlags['de'] },
  'fr': { tag: AMAZON_API_DOMAIN_PARAMETERS.fr.PartnerTag, name: 'צרפת', flag: amazonDomainFlags['fr'] },
  'it': { tag: AMAZON_API_DOMAIN_PARAMETERS.it.PartnerTag, name: 'איטליה', flag: amazonDomainFlags['it'] },
  'es': { tag: AMAZON_API_DOMAIN_PARAMETERS.es.PartnerTag, name: 'ספרד', flag: amazonDomainFlags['es'] },
  'jp': { tag: 'botimza-22', name: 'יפן', flag: amazonDomainFlags['jp'] }
};

/**
 * Get the base Amazon URL for a domain key
 * Only 'jp' needs special handling: amazon.co.jp (not amazon.jp)
 */
const getAmazonBaseUrl = (domain) => {
  if (domain === 'jp') return 'amazon.co.jp';
  return `amazon.${domain}`;
};

/**
 * Create affiliated search URL for missing domains
 * @param {string} domain - Amazon domain
 * @param {string} searchTerm - Search term
 * @returns {string} Affiliated search URL
 */
export const createAffiliatedSearchUrl = (domain, searchTerm) => {
  const domainInfo = AMAZON_DOMAINS[domain];
  if (!domainInfo || !searchTerm) return '';
  
  const baseUrl = getAmazonBaseUrl(domain);
  const encodedSearchTerm = encodeURIComponent(searchTerm);
  return `https://www.${baseUrl}/s?k=${encodedSearchTerm}&tag=${domainInfo.tag}&linkCode=ur2&linkId=1a200153da918ee9b06f339f909a98e5&camp=1789&creative=9325`;
};

/**
 * Create affiliated direct product URL for a specific ASIN
 * Used when the search term was a URL and the ASIN was extracted
 * @param {string} domain - Amazon domain
 * @param {string} asin - Product ASIN
 * @returns {string} Affiliated product page URL
 */
export const createAffiliatedAsinUrl = (domain, asin) => {
  const domainInfo = AMAZON_DOMAINS[domain];
  if (!domainInfo || !asin) return '';
  
  const baseUrl = getAmazonBaseUrl(domain);
  return `https://www.${baseUrl}/dp/${asin}?tag=${domainInfo.tag}&linkCode=ur2&linkId=1a200153da918ee9b06f339f909a98e5&camp=1789&creative=9325`;
};
